/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './CustomAssistantsService';
import * as Queries from './CustomAssistantsService.dfc.new';
import type { AdditionalContextArgs } from './CustomAssistantsService.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;
type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseGetCustomAssistantQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetCustomAssistantResponseType>,
    References.GetCustomAssistantRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getCustomAssistant',
            References.GetCustomAssistantResponseType
          >
        : References.GetCustomAssistantResponseType)
    | undefined;
};

export function useGetCustomAssistantQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetCustomAssistantResponseType>,
    References.GetCustomAssistantRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetCustomAssistantQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_CUSTOM_ASSISTANT_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getCustomAssistant: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetCustomAssistantQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetCustomAssistantQueryReturn<T>;
}

type UseGetCustomAssistantLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetCustomAssistantResponseType>,
    References.GetCustomAssistantRequestType,
    T extends true
      ? Record<'getCustomAssistant', References.GetCustomAssistantResponseType>
      : References.GetCustomAssistantResponseType
  >;

export function useGetCustomAssistantLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetCustomAssistantResponseType>,
    References.GetCustomAssistantRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetCustomAssistantLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_CUSTOM_ASSISTANT_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getCustomAssistant: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetCustomAssistantLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetCustomAssistantLazyQueryReturn<T>;
}

type UseGetCustomAssistantSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetCustomAssistantResponseType>,
    References.GetCustomAssistantRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getCustomAssistant', References.GetCustomAssistantResponseType>
    : References.GetCustomAssistantResponseType;
};

export function useGetCustomAssistantSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetCustomAssistantResponseType>,
    References.GetCustomAssistantRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetCustomAssistantSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_CUSTOM_ASSISTANT_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getCustomAssistant: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetCustomAssistantSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetCustomAssistantSuspenseQueryReturn<T>;
}

type UseGetConversationStartersQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetConversationStartersResponseType>,
    References.GetConversationStartersRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getConversationStarters',
            References.GetConversationStartersResponseType
          >
        : References.GetConversationStartersResponseType)
    | undefined;
};

export function useGetConversationStartersQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetConversationStartersResponseType>,
    References.GetConversationStartersRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetConversationStartersQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_CONVERSATION_STARTERS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getConversationStarters: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetConversationStartersQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetConversationStartersQueryReturn<T>;
}

type UseGetConversationStartersLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetConversationStartersResponseType>,
    References.GetConversationStartersRequestType,
    T extends true
      ? Record<
          'getConversationStarters',
          References.GetConversationStartersResponseType
        >
      : References.GetConversationStartersResponseType
  >;

export function useGetConversationStartersLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetConversationStartersResponseType>,
    References.GetConversationStartersRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetConversationStartersLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_CONVERSATION_STARTERS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getConversationStarters: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetConversationStartersLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetConversationStartersLazyQueryReturn<T>;
}

type UseGetConversationStartersSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetConversationStartersResponseType>,
    References.GetConversationStartersRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getConversationStarters',
        References.GetConversationStartersResponseType
      >
    : References.GetConversationStartersResponseType;
};

export function useGetConversationStartersSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetConversationStartersResponseType>,
    References.GetConversationStartersRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetConversationStartersSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_CONVERSATION_STARTERS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getConversationStarters: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetConversationStartersSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetConversationStartersSuspenseQueryReturn<T>;
}

type UseListCustomAssistantsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.ListCustomAssistantsResponseType>,
    References.ListCustomAssistantsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'listCustomAssistants',
            References.ListCustomAssistantsResponseType
          >
        : References.ListCustomAssistantsResponseType)
    | undefined;
};

export function useListCustomAssistantsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.ListCustomAssistantsResponseType>,
    References.ListCustomAssistantsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListCustomAssistantsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.LIST_CUSTOM_ASSISTANTS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            listCustomAssistants: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseListCustomAssistantsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseListCustomAssistantsQueryReturn<T>;
}

type UseListCustomAssistantsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.ListCustomAssistantsResponseType>,
    References.ListCustomAssistantsRequestType,
    T extends true
      ? Record<
          'listCustomAssistants',
          References.ListCustomAssistantsResponseType
        >
      : References.ListCustomAssistantsResponseType
  >;

export function useListCustomAssistantsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.ListCustomAssistantsResponseType>,
    References.ListCustomAssistantsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListCustomAssistantsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.LIST_CUSTOM_ASSISTANTS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            listCustomAssistants: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseListCustomAssistantsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseListCustomAssistantsLazyQueryReturn<T>;
}

type UseListCustomAssistantsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.ListCustomAssistantsResponseType>,
    References.ListCustomAssistantsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'listCustomAssistants',
        References.ListCustomAssistantsResponseType
      >
    : References.ListCustomAssistantsResponseType;
};

export function useListCustomAssistantsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.ListCustomAssistantsResponseType>,
    References.ListCustomAssistantsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListCustomAssistantsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.LIST_CUSTOM_ASSISTANTS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            listCustomAssistants: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseListCustomAssistantsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseListCustomAssistantsSuspenseQueryReturn<T>;
}

type UseCreateCustomAssistantMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.CreateCustomAssistantResponseType>,
    References.CreateCustomAssistantRequestType,
    T extends true
      ? Record<
          'createCustomAssistant',
          References.CreateCustomAssistantResponseType
        >
      : References.CreateCustomAssistantResponseType
  >;

export function useCreateCustomAssistantMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.CreateCustomAssistantResponseType>,
    References.CreateCustomAssistantRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCreateCustomAssistantMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.CREATE_CUSTOM_ASSISTANT_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            createCustomAssistant: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseCreateCustomAssistantMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseCreateCustomAssistantMutationReturn<T>;
}

type UseDuplicateCustomAssistantMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.DuplicateCustomAssistantResponseType>,
    References.DuplicateCustomAssistantRequestType,
    T extends true
      ? Record<
          'duplicateCustomAssistant',
          References.DuplicateCustomAssistantResponseType
        >
      : References.DuplicateCustomAssistantResponseType
  >;

export function useDuplicateCustomAssistantMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.DuplicateCustomAssistantResponseType>,
    References.DuplicateCustomAssistantRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseDuplicateCustomAssistantMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.DUPLICATE_CUSTOM_ASSISTANT_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            duplicateCustomAssistant: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseDuplicateCustomAssistantMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseDuplicateCustomAssistantMutationReturn<T>;
}

type UseUpdateCustomAssistantMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.UpdateCustomAssistantResponseType>,
    References.UpdateCustomAssistantRequestType,
    T extends true
      ? Record<
          'updateCustomAssistant',
          References.UpdateCustomAssistantResponseType
        >
      : References.UpdateCustomAssistantResponseType
  >;

export function useUpdateCustomAssistantMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UpdateCustomAssistantResponseType>,
    References.UpdateCustomAssistantRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateCustomAssistantMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_CUSTOM_ASSISTANT_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateCustomAssistant: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateCustomAssistantMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateCustomAssistantMutationReturn<T>;
}

type UseDeleteCustomAssistantMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.DeleteCustomAssistantResponseType>,
    References.DeleteCustomAssistantRequestType,
    T extends true
      ? Record<
          'deleteCustomAssistant',
          References.DeleteCustomAssistantResponseType
        >
      : References.DeleteCustomAssistantResponseType
  >;

export function useDeleteCustomAssistantMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.DeleteCustomAssistantResponseType>,
    References.DeleteCustomAssistantRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseDeleteCustomAssistantMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.DELETE_CUSTOM_ASSISTANT_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            deleteCustomAssistant: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseDeleteCustomAssistantMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseDeleteCustomAssistantMutationReturn<T>;
}

type UseInstallCustomAssistantTemplateFromGlobalIdMutationReturn<
  T extends boolean,
> = MutationTupleOverride<
  Record<
    'result',
    References.InstallCustomAssistantTemplateFromGlobalIdResponseType
  >,
  References.InstallCustomAssistantTemplateFromGlobalIdRequestType,
  T extends true
    ? Record<
        'installCustomAssistantTemplateFromGlobalId',
        References.InstallCustomAssistantTemplateFromGlobalIdResponseType
      >
    : References.InstallCustomAssistantTemplateFromGlobalIdResponseType
>;

export function useInstallCustomAssistantTemplateFromGlobalIdMutation<
  T extends boolean = false,
>(
  options?: MutationHookOptions<
    Record<
      'result',
      References.InstallCustomAssistantTemplateFromGlobalIdResponseType
    >,
    References.InstallCustomAssistantTemplateFromGlobalIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseInstallCustomAssistantTemplateFromGlobalIdMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.INSTALL_CUSTOM_ASSISTANT_TEMPLATE_FROM_GLOBAL_ID_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            installCustomAssistantTemplateFromGlobalId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseInstallCustomAssistantTemplateFromGlobalIdMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseInstallCustomAssistantTemplateFromGlobalIdMutationReturn<T>;
}

type UseLookupUserInstalledAssistantByGlobalIdQueryReturn<T extends boolean> =
  Omit<
    QueryResult<
      Record<
        'result',
        References.LookupUserInstalledAssistantByGlobalIdResponseType
      >,
      References.LookupUserInstalledAssistantByGlobalIdRequestType
    >,
    'data'
  > & {
    data:
      | (T extends true
          ? Record<
              'lookupUserInstalledAssistantByGlobalId',
              References.LookupUserInstalledAssistantByGlobalIdResponseType
            >
          : References.LookupUserInstalledAssistantByGlobalIdResponseType)
      | undefined;
  };

export function useLookupUserInstalledAssistantByGlobalIdQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<
      'result',
      References.LookupUserInstalledAssistantByGlobalIdResponseType
    >,
    References.LookupUserInstalledAssistantByGlobalIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseLookupUserInstalledAssistantByGlobalIdQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.LOOKUP_USER_INSTALLED_ASSISTANT_BY_GLOBAL_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            lookupUserInstalledAssistantByGlobalId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseLookupUserInstalledAssistantByGlobalIdQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseLookupUserInstalledAssistantByGlobalIdQueryReturn<T>;
}

type UseLookupUserInstalledAssistantByGlobalIdLazyQueryReturn<
  T extends boolean,
> = LazyQueryResultTupleOverride<
  Record<
    'result',
    References.LookupUserInstalledAssistantByGlobalIdResponseType
  >,
  References.LookupUserInstalledAssistantByGlobalIdRequestType,
  T extends true
    ? Record<
        'lookupUserInstalledAssistantByGlobalId',
        References.LookupUserInstalledAssistantByGlobalIdResponseType
      >
    : References.LookupUserInstalledAssistantByGlobalIdResponseType
>;

export function useLookupUserInstalledAssistantByGlobalIdLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<
      'result',
      References.LookupUserInstalledAssistantByGlobalIdResponseType
    >,
    References.LookupUserInstalledAssistantByGlobalIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseLookupUserInstalledAssistantByGlobalIdLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.LOOKUP_USER_INSTALLED_ASSISTANT_BY_GLOBAL_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            lookupUserInstalledAssistantByGlobalId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseLookupUserInstalledAssistantByGlobalIdLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseLookupUserInstalledAssistantByGlobalIdLazyQueryReturn<T>;
}

type UseLookupUserInstalledAssistantByGlobalIdSuspenseQueryReturn<
  T extends boolean,
> = Omit<
  UseSuspenseQueryResult<
    Record<
      'result',
      References.LookupUserInstalledAssistantByGlobalIdResponseType
    >,
    References.LookupUserInstalledAssistantByGlobalIdRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'lookupUserInstalledAssistantByGlobalId',
        References.LookupUserInstalledAssistantByGlobalIdResponseType
      >
    : References.LookupUserInstalledAssistantByGlobalIdResponseType;
};

export function useLookupUserInstalledAssistantByGlobalIdSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<
      'result',
      References.LookupUserInstalledAssistantByGlobalIdResponseType
    >,
    References.LookupUserInstalledAssistantByGlobalIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseLookupUserInstalledAssistantByGlobalIdSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.LOOKUP_USER_INSTALLED_ASSISTANT_BY_GLOBAL_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            lookupUserInstalledAssistantByGlobalId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseLookupUserInstalledAssistantByGlobalIdSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseLookupUserInstalledAssistantByGlobalIdSuspenseQueryReturn<T>;
}

type UseFindAssistantsByResourceIdQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.FindAssistantsByResourceIdResponseType>,
    References.FindAssistantsByResourceIdRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'findAssistantsByResourceId',
            References.FindAssistantsByResourceIdResponseType
          >
        : References.FindAssistantsByResourceIdResponseType)
    | undefined;
};

export function useFindAssistantsByResourceIdQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.FindAssistantsByResourceIdResponseType>,
    References.FindAssistantsByResourceIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFindAssistantsByResourceIdQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.FIND_ASSISTANTS_BY_RESOURCE_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            findAssistantsByResourceId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFindAssistantsByResourceIdQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseFindAssistantsByResourceIdQueryReturn<T>;
}

type UseFindAssistantsByResourceIdLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.FindAssistantsByResourceIdResponseType>,
    References.FindAssistantsByResourceIdRequestType,
    T extends true
      ? Record<
          'findAssistantsByResourceId',
          References.FindAssistantsByResourceIdResponseType
        >
      : References.FindAssistantsByResourceIdResponseType
  >;

export function useFindAssistantsByResourceIdLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.FindAssistantsByResourceIdResponseType>,
    References.FindAssistantsByResourceIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFindAssistantsByResourceIdLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.FIND_ASSISTANTS_BY_RESOURCE_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            findAssistantsByResourceId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseFindAssistantsByResourceIdLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseFindAssistantsByResourceIdLazyQueryReturn<T>;
}

type UseFindAssistantsByResourceIdSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.FindAssistantsByResourceIdResponseType>,
    References.FindAssistantsByResourceIdRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'findAssistantsByResourceId',
        References.FindAssistantsByResourceIdResponseType
      >
    : References.FindAssistantsByResourceIdResponseType;
};

export function useFindAssistantsByResourceIdSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.FindAssistantsByResourceIdResponseType>,
    References.FindAssistantsByResourceIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFindAssistantsByResourceIdSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.FIND_ASSISTANTS_BY_RESOURCE_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            findAssistantsByResourceId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFindAssistantsByResourceIdSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseFindAssistantsByResourceIdSuspenseQueryReturn<T>;
}

type UseSubmitPromptFeedbackMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.SubmitPromptFeedbackResponseType>,
    References.SubmitPromptFeedbackRequestType,
    T extends true
      ? Record<
          'submitPromptFeedback',
          References.SubmitPromptFeedbackResponseType
        >
      : References.SubmitPromptFeedbackResponseType
  >;

export function useSubmitPromptFeedbackMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.SubmitPromptFeedbackResponseType>,
    References.SubmitPromptFeedbackRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSubmitPromptFeedbackMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.SUBMIT_PROMPT_FEEDBACK_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            submitPromptFeedback: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseSubmitPromptFeedbackMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseSubmitPromptFeedbackMutationReturn<T>;
}
